/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
/**

Coded by www.techhighway.ca

*/

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDSwitch from "components/MDSwitch";
import MDTypography from "components/MDTypography";
import UserService from "services/user-service";

// react-router-dom components
import { Link, useLocation } from "react-router-dom";

import { PreserveTable, useCache } from "context";
import { useContext, useEffect, useState } from "react";

// @mui icons
import Icon from "@mui/material/Icon";

// Images
import customAlert from "components/MDAlert/customAlert";
import authPermission from "utility/auth-permissions";
import { formatDateTime, ucWords } from "utility/helpers";
import UserAvatar from "utility/user-avatar";

export default function data() {
  const [userData, setUserData] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedId, setSelectedId] = useState("");
  const { openAlertSB, closeAlertSB, renderAlertSB } = customAlert();

  const { hasPermission } = authPermission();
  const pagePermission = hasPermission("/user-management");
  const preserveTable = useContext(PreserveTable);
  const { page_no, page_size, sort_column, sort_column_value, search_value } = preserveTable?.user;
  const loggedUserId = localStorage.getItem("user_id");

  const [totalData, setTotalData] = useState(0);
  const { cacheItems, setCacheItems } = useCache();
  const [isData, setIsData] = useState(false);
  const location = useLocation();

  const handleClickOpen = (id) => {
    setSelectedId(id);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const getUserData = async (page, pageSize, sortColumn, sortColumnValue, searchValue) => {
    const response = await UserService.getUsers(
      page,
      pageSize,
      sortColumn,
      sortColumnValue,
      searchValue
    );
    setUserData(response?.data);
    setTotalData(response?.total);
  };

  useEffect(() => {
    if (location?.state?.color) {
      openAlertSB(location?.state);
      setTimeout(function () {
        closeAlertSB();
      }, 3000);
    }
    // getUserData(page_no, page_size, sort_column, sort_column_value, search_value);
  }, []);

  const getData = async (page_no, page_size, sortColumn, sortColumnValue, searchWord) => {
    const preserveData = {
      page_no,
      page_size,
      sort_column: sortColumn,
      sort_column_value: sortColumnValue,
      search_value: searchWord,
    };
    preserveTable.setPreserveUser(preserveData);
    getUserData(page_no, page_size, sortColumn, sortColumnValue, searchWord);
    setIsData(true);
  };

  const updateUserStatus = async (id, status) => {
    try {
      const data = { active: status };
      const res = await UserService.updateUserStatus(id, data);
      if (res) {
        if (
          cacheItems.hasOwnProperty("users") ||
          cacheItems.hasOwnProperty("Client")
        ) {
          // Create a new object without the key
          const { users, salesperson, ...rest } = cacheItems; // Destructure to exclude key
          setCacheItems(rest); // Set the new cache items without key
        }
        openAlertSB({ color: "success", icon: "check", msg: res, title: "User" });
        setTimeout(function () {
          closeAlertSB();
        }, 3000);
        const response = await UserService.getUsers(
          page_no,
          page_size,
          sort_column,
          sort_column_value,
          search_value
        );
        setUserData(response?.data);
        setTotalData(response?.total);
      }
    } catch (res) {
      if (res.hasOwnProperty("message")) {
        openAlertSB({ color: "error", icon: "warning", msg: res.message, title: "User" });
        setTimeout(function () {
          closeAlertSB();
        }, 4000);
      } else {
        openAlertSB({ color: "error", icon: "warning", msg: res.errors[0].detail, title: "User" });
        setTimeout(function () {
          closeAlertSB();
        }, 4000);
      }
    }
  };

  const deleteUser = async (id) => {
    try {
      const response = await UserService.deleteUser(id);
      if (
        cacheItems.hasOwnProperty("users") ||
        cacheItems.hasOwnProperty("client")
      ) {
        // Create a new object without the key
        const { users, salesperson, ...rest } = cacheItems; // Destructure to exclude key
        setCacheItems(rest); // Set the new cache items without key
      }
      openAlertSB({ color: "success", icon: "check", msg: response, title: "User" });
      setTimeout(function () {
        closeAlertSB();
      }, 4000);
    } catch (res) {
      if (res.hasOwnProperty("message")) {
        openAlertSB({ color: "error", icon: "warning", msg: res.message, title: "User" });
        setTimeout(function () {
          closeAlertSB();
        }, 4000);
      } else {
        openAlertSB({ color: "error", icon: "warning", msg: res.errors[0].detail, title: "User" });
        setTimeout(function () {
          closeAlertSB();
        }, 4000);
      }
    }
    setSelectedId("");
    handleClose();
    getUserData(page_no, page_size, sort_column, sort_column_value, search_value);
  };

  const Author = ({ name, email }) => (
    <MDBox display="flex" alignItems="center" lineHeight={1}>
      <UserAvatar name={name} size="sm" />
      <MDBox ml={2} lineHeight={1}>
        <MDTypography display="block" variant="body2">
          {name}
        </MDTypography>
        <MDTypography variant="caption">{email}</MDTypography>
      </MDBox>
    </MDBox>
  );

  const Job = ({ title, description }) => (
    <MDBox lineHeight={1} textAlign="left">
      <MDTypography display="block" variant="body2" color="text">
        {title}
      </MDTypography>
      <MDTypography variant="caption">{description}</MDTypography>
    </MDBox>
  );

  const rows = [];
  userData?.map((eachUser, index) => {
    const cols = {
      id: (
        <MDTypography
          component={Link}
          to={
            eachUser.id != loggedUserId && pagePermission.edit
              ? `/user-management/edit?id=${eachUser.id}`
              : ""
          }
          variant="body2"
          color="text"
        >
          {eachUser.id}
        </MDTypography>
      ),
      first_name: (
        <Author
          name={`${
            eachUser.first_name + (eachUser.middle_name ? ` ${eachUser.middle_name}` : "")
          } ${eachUser.last_name}`}
          email=""
        />
      ),
      role: <Job title={ucWords(eachUser.role)} description="" />,
      email: (
        <MDTypography component="a" href="#" variant="body2" color="text">
          {eachUser.email}
        </MDTypography>
      ),
      created_at: (
        <MDTypography component="a" href="#" variant="body2" color="text" whiteSpace="nowrap">
          {formatDateTime(eachUser.created_at)}
        </MDTypography>
      ),
      action:
        eachUser.id != loggedUserId ? (
          <MDBox display="flex">
            {pagePermission.status ? (
              <MDSwitch
                checked={!!eachUser.active}
                color="info"
                title="Active Status"
                onChange={() => updateUserStatus(eachUser.id, !eachUser.active)}
              />
            ) : (
              ""
            )}
            {pagePermission.edit ? (
              <MDTypography
                mr={1}
                mt={1}
                component={Link}
                to={`/user-management/edit?id=${eachUser.id}`}
                display="block"
                variant="body2"
                color="info"
                title="Edit"
              >
                <Icon fontSize="medium">edit</Icon>
              </MDTypography>
            ) : (
              ""
            )}
            {pagePermission.new ? (
              <MDTypography
                mr={1}
                mt={1}
                component={Link}
                to={`/user-management/add?id=${eachUser.id}`}
                title="Copy"
                display="block"
                variant="caption"
                color="secondary"
                fontWeight="medium"
              >
                <Icon fontSize="medium">content_copy_icon</Icon>
              </MDTypography>
            ) : (
              ""
            )}
            {pagePermission.remove ? (
              <MDTypography
                mt={1}
                title="Remove"
                component={Link}
                onClick={() => handleClickOpen(eachUser.id)}
                display="block"
                variant="body2"
                color="error"
              >
                <Icon fontSize="medium">delete</Icon>
              </MDTypography>
            ) : (
              ""
            )}
            {renderAlertSB}
          </MDBox>
        ) : (
          ""
        ),
    };
    rows[index] = cols;
  });

  return {
    columns: [
      { Header: "id", accessor: "id", width: "10%", align: "left" },
      { Header: "user", accessor: "first_name", width: "28%", align: "left" },
      { Header: "email", accessor: "email", width: "27%", align: "left" },
      { Header: "role", accessor: "role", width: "8%", align: "left" },
      { Header: "creation date", accessor: "created_at", width: "18%", align: "center" },
      ...(pagePermission.edit || pagePermission.remove || pagePermission.status
        ? [{ Header: "actions", accessor: "action", align: "center" }]
        : []),
    ],

    rows,
    open,
    handleClickOpen,
    handleClose,
    deleteUser,
    selectedId,
    pagePermission,
    totalData,
    page: page_no,
    pageSize: page_size,
    getData,
    sortColumn: sort_column,
    sortColumnValue: sort_column_value,
    searchValue: search_value,
    isData: isData,
  };
}
